import { axios } from "common/helpers"

export function get() {
    return axios.get("/api/users")
}

export function update(user) {
    const { company, ...rest } = user
    return axios.patch(`/api/users/${user.id}`, {
        ...rest,
        company: company?.id || null
    })
}

export function updateSelf(user) {
    const { company, ...rest } = user
    return axios.patch("/api/users/me", { ...rest, company: company?.id })
}

export function create(user) {
    const { company, ...rest } = user
    return axios.post("/api/users/create", {
        ...rest,
        company: company?.id || null
    })
}

export async function remove(id) {
    await axios.delete(`/api/users/${id}`)
}
